import styled from 'styled-components';
import { ASSETS } from '../../../assets';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: url(${ASSETS.REGISTRATION_PAGE_BACKGROUND}) no-repeat top;
  background-size: cover;
`;
